export const courseData = [
  {
    image: "assets/images/course/science.png",
    courseName: "Language",
    stream: "Arts",
    courseDesc: ["English (Compulsory)", "Hindi"],
  },
  {
    image: "assets/images/course/science.png",
    courseName: "Science",
    stream: "Science",
    courseDesc: [
      "PCMB (Physics, Chemistry, Mathematics, Biology)",
      "PCMC (Physics, Chemistry, Mathematics, Computer Science)",
      "PCME (Physics, Chemistry, Mathematics, Electronics)",
    ],
  },
  {
    image: "assets/images/course/commerce.jpg",
    courseName: "Commerce",
    stream: "Commerce",
    courseDesc: [
      "CAMS (Business Studies, Accountancy, Mathematics, Statistics)",
      "CAME (Business Studies, Accountancy, Mathematics, Economics)",
    ],
  },
  {
    image: "assets/images/course/arts.jpg",
    courseName: "Arts",
    stream: "Arts",
    courseDesc: [
      "PPES (Psychology, Political Science, Economics, Sociology)",
      "HESP (History, Economics, Sociology, Political Science)",
      "HEPP (History, Economics, Political Science, Psychology)",
    ],
  },
];